// https: //www.figma.com/design/XkfPDhiRbUtc1mgwzNzIiU/Organism%3A-CMS--Sortimentsteaser?node-id=24-106&node-type=canvas&t=iQo5jXgsVRWcHwk7-0

:host {
  display: block;
  margin-bottom: var(--cms-components-mb);
}

.assortment-teaser-container {
  @include cms-default-grid-container;
}

.assortment-teaser-container {
  margin-bottom: var(--cms-spacing-150);

  .assortment-teaser {
    grid-area: var(--cms-default-grid-area);
    display: grid;
    grid-template-rows: fit-content(100%);

    .image-container {
      padding: var(--cms-spacing-150) var(--cms-spacing-075);
      background-color: var(--cms-semanticColors-base-medium-background);
      text-align: center;

      .teaser-image {
        mix-blend-mode: multiply;
        border-style: none;
        height: auto;
        max-width: 100%;
        vertical-align: middle;
      }
    }

    .cta-wrapper {
      background-color: var(--cms-semanticColors-container-weak-background);
      text-align: center;
      padding: var(--cms-spacing-100) var(--cms-spacing-050);
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .assortment-cta {
      display: flex;
      justify-content: center;
    }
  }
}

.assortment-overview-cta,
.assortment-cta {
  text-align: center;
  @include label-font-125;
  text-decoration: none;
}

.assortment-overview-cta {
  color: var(--cms-theme-text-color);
  border-bottom: 2px solid var(--cms-theme-border-color);

  &:hover {
    border-color: var(--cms-semanticColors-transparency-strong-background);
  }
}

@include media-width($breakpoint-sm) {
  .assortment-teaser-container .assortment-teaser {
    --cms-default-grid-area: auto / auto / auto / span 4;
  }

  .assortment-overview-cta {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }
}
